import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import SaleFooter from '../SaleFooter/SaleFooter';
import {goToPage, reportAnalytics, setCellularServices, removeSelectedPhone, removeProduct, setIsMeshUpgrade} from '../saleBlockSlice';
import MeshUpgrade from '../MeshUpgrade/MeshUpgrade';

const MeshUpgradePage = (props) => {
  let flowType = props.flowType;

  useEffect(() => {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: (flowType == 'existsCustomer' ? 'visibility_26a' : 'visibility_19'), eventLabel: eventLabel});
  }, []);

  //page params
  let isDisplayFooter = true;
  const btnText = 'נמשיך לסיכום';
  let currentPageFunction = handleMeshUpgradeContinue;
  let totalPrice = props.totalPrice;
  let totalPriceOneTime = props.totalPriceOneTime;  
  let priceText = 'לחודש';
  let formid = 'sale';
  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
      <h1 className='sale-title-big'> מה עם גלישה טובה יותר בכל הבית?</h1>
      <h2 className='sale-title-small'> כמה אפשרויות נוספות לחוויה אופטימלית </h2>
    </div>
  );

  let currentPageView = <MeshUpgrade onClickMeshUpgradeBtn={handleOnClickMeshUpgradeBtn} isMeshUpgrade={props.isMeshUpgrade} />;

  function handleOnClickMeshUpgradeBtn(isMeshUpgrade) {
    props.setIsMeshUpgrade(isMeshUpgrade);
  }

  function handleMeshUpgradeContinue() {
    if (flowType == 'existsCustomer') {
      props.goToPage({page: 'summaryPage', percent: 84});
    } else {
      props.goToPage({page: 'summaryPage', percent: 80});
    }

    let eventLabel = props.productsInfo.selectedProducts[0]?.name + ' isMeshUpgrade = ' + props.isMeshUpgrade;
    props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: (flowType == 'existsCustomer' ? 'click_36a' : 'click_25'), eventLabel: eventLabel});
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        {currentPageView}
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          removeProduct={removeProduct}
          onclick={currentPageFunction}
          price={totalPrice}
          totalPriceOneTime={totalPriceOneTime}          
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    configuration: state.saleBlock.epiServer.configuration,
    service: state.saleBlock.epiServer.service,
    totalPrice: state.saleBlock.totalPrice,
    totalPriceOneTime: state.saleBlock.totalPriceOneTime,    
    chooseNumber: state.saleBlock.chooseNumber,
    productsInfo: state.saleBlock.productsInfo,
    isMeshUpgrade: state.saleBlock.isMeshUpgrade,

    //other states
    _chooseCellularServices: state.chooseCellularServices.form,
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  setCellularServices,
  removeSelectedPhone,
  removeProduct,
  setIsMeshUpgrade,
};

export default connect(mapStateToProps, mapDispatchToProps)(MeshUpgradePage);
